module.exports = __webpack_public_path__ + "static/img/l6.fbef957.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing_page/l6.jpg
// module id = 639
// module chunks = 0